import type { User } from '@/api/client';

/** Имя пользователя с аккаунтом для подписей «кто сменил этап»: имя из ответа сервера или имя и фамилия; нет — «Пользователь» */
export function userDisplayNameOrPlaceholder(u: Pick<User, 'name' | 'first_name' | 'last_name'>): string {
  const n = u.name?.trim() || `${u.first_name} ${u.last_name}`.trim();
  return n || 'Пользователь';
}
